<script setup lang="ts">
import { useCalendarStore } from "@/PC/store/calendarStore";
import { useInputStore } from "@/PC/store/inputStore";
import { getSecondaryHour } from "@/common/helpers/timezoneUtils";
import { storeToRefs } from "pinia";
import { range } from "lodash"
import { ref, computed } from "vue";

const calendarStore = useCalendarStore()
const { hourHeight } = calendarStore
const hours = ref(range(0, 24))

const { secondaryTimeZone } = storeToRefs(useInputStore())

const secondaryHours = computed(() => {
  if (!secondaryTimeZone.value) return null
  return hours.value.map(h => {
    const result = getSecondaryHour(h, calendarStore.currentPageFirstDate, secondaryTimeZone.value!)
    const hStr = result.hour < 10 ? '0' + result.hour : String(result.hour)
    const mStr = result.minute < 10 ? '0' + result.minute : String(result.minute)
    return `${hStr}:${mStr}`
  })
})
</script>

<template>
  <div class="hours-label-container lo-h-inline-flex-start">
    <div class="hours-label">
      <!-- Hour label -->
      <div
        class="hour-label"
        v-for="(hour, idx) in hours"
        :style="{ height: hourHeight.toPx() }"
        :key="hour"
      >
        <roboto v-if="secondaryHours" class="size-14px gray-2 secondary-hour">{{ secondaryHours[idx] }}</roboto>
        <roboto class="size-14px gray-1">{{ hour.toFullHour() }}:00</roboto>
      </div>
    </div>
    <!-- Horizontal Beard lines -->
    <div class="lo-v horizontal-lines" :style="{}">
      <div
        class="horizontal-line"
        v-for="idx in 24"
        :key="idx"
        :style="{ height: hourHeight.toPx(), width: '4px' }"
      />
    </div>
  </div>
</template>

<style scoped>
.hours-label-container {
  width: var(--hour-label-width);
}
.hours-label {
  /* 9pxは時間のラベルを線の中心にずらすための差分 */
  margin-top: -9px;
  position: relative;
  padding-left: var(--base-8px);
  /* 調整値 */
  padding-right: 15px;
}
.hour-label {
  display: flex;
  gap: 6px;
}
.secondary-hour {
  white-space: nowrap;
}
.horizontal-line {
  border-color: var(--border-black) !important;
  opacity: 1;
  border-top: 1px solid;
  margin-left: -4px;
}
</style>
